import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Box, Chip, FormControl, IconButton, InputAdornment, OutlinedInput, Switch, Tooltip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import axiosInstance from '../../../../config/axio.config';
import { useShowMessages } from '../../../../hooks/useMessages/useMessages';
import CustomTableCell from '../../../shared/CustomTable/CustomTableCell';

const url = '/systems';

export default function SystemsTable(props) {
  const { ShowMessage } = useShowMessages();
  const [search, setSearch] = useState('');
  const [toggling, setToggling] = useState(null);

  const handleToggle = async (system) => {
    setToggling(system.id);
    try {
      await axiosInstance.patch(`${url}/${system.id}/toggle`);
      props.handleChanged();
    } catch (error) {
      ShowMessage('error', error.response?.data?.message || 'Erro ao alterar a situação do sistema');
    } finally {
      setToggling(null);
    }
  };

  const filtered = (props.systems || []).filter((system) => {
    const term = search.toLowerCase();
    return system.description?.toLowerCase().includes(term) || system.type?.toLowerCase().includes(term);
  });

  return (
    <Box sx={{ width: '100%', padding: 1 }}>
      <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
        <FormControl variant="outlined" size="small" fullWidth>
          <OutlinedInput
            placeholder="Pesquisar por descrição ou tipo"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            endAdornment={
              <InputAdornment position="end">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            }
          />
        </FormControl>
      </Box>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer sx={{ overflow: 'scroll', height: '70vh' }}>
          <Table stickyHeader sx={{ width: '100%' }}>
            <TableHead>
              <TableRow>
                <CustomTableCell>ID</CustomTableCell>
                <CustomTableCell>Descrição</CustomTableCell>
                <CustomTableCell>Tipo</CustomTableCell>
                <CustomTableCell align="center">Situação</CustomTableCell>
                <CustomTableCell align="center">Ativo</CustomTableCell>
                <CustomTableCell align="center">Ações</CustomTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filtered.map((row) => (
                <TableRow key={row.id}>
                  <CustomTableCell component="th" scope="row">{row.id}</CustomTableCell>
                  <CustomTableCell>{row.description}</CustomTableCell>
                  <CustomTableCell>{row.type}</CustomTableCell>
                  <CustomTableCell align="center">
                    <Chip
                      label={row.active === 'Y' ? 'Ativo' : 'Inativo'}
                      color={row.active === 'Y' ? 'success' : 'default'}
                      size="small"
                    />
                  </CustomTableCell>
                  <CustomTableCell align="center">
                    <Switch
                      checked={row.active === 'Y'}
                      onChange={() => handleToggle(row)}
                      disabled={toggling === row.id}
                      size="small"
                    />
                  </CustomTableCell>
                  <CustomTableCell align="center">
                    <Tooltip title="Editar">
                      <IconButton size="small" onClick={() => props.handleEdit(row)}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </CustomTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}
